import(/* webpackMode: "eager" */ "/vercel/path0/app/work/[slug]/page.tsx");
